import m from "mithril";
import select_sequence_1 from "./select_sequence_1/index";
import task_list_1 from "./task_list_1/index";

export default ({attrs: {editable, customformat, text, onUpdate}}) => {
	// console.log({customformat});
	return {
		view: () => {
			if (customformat.name == "select_sequence_1")
				return m(select_sequence_1, {editable, customformat, text, onUpdate});
			if (customformat.name == "task_list_1") return m(task_list_1, {editable, customformat, text, onUpdate});
		},
	};
};
